const { map } = require('lodash');

function createProductTile(product) {
    return {
        id: product.Stockcode,
        type: 'product',
        data: {
            product,
        },
    };
}

function createProductTiles(products) {
    return map(products, product => createProductTile(product));
}

function createBundleTile(bundle) {
    if (bundle.Products.length === 1) {
        return createProductTile(bundle.Products[0]);
    }

    return {
        id: bundle.Name,
        type: 'bundle',
        data: {
            bundle,
        },
    };
}

function createBundleTiles(bundles, forceResponsive = false, isDetail = false, sfResponsive = false) {
    return map(bundles, bundle => createBundleTile(bundle, forceResponsive, isDetail, sfResponsive));
}

module.exports = {
    createBundleTile,
    createBundleTiles,
    createProductTile,
    createProductTiles,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/product-tile-factory.js